import { atom, selector, useRecoilTransaction_UNSTABLE } from 'recoil';

import { InviteConsulteeRequest } from 'api';
import { ValueLabelResponse, ApplicationUser } from 'types';

export const removeUserState = atom<ApplicationUser | undefined>({
  key: 'removeUser',
  default: undefined,
});

export const showRemoveUserModalState = atom<boolean>({
  key: 'showRemoveUserModal',
  default: false,
});

export const showInviteUserModalState = atom<boolean>({
  key: 'showInviteUserModal',
  default: false,
});

export const manageUsersPageSizeState = atom<number>({
  key: 'manageUsersPageSize',
  default: 10,
});

export const manageUsersPageNumberState = atom<number>({
  key: 'manageUsersPageNumber',
  default: 1,
});

export const manageUsersSearchState = atom<string>({
  key: 'manageUsersSearch',
  default: '',
});

export const manageUsersFilterTeamState = atom<number>({
  key: 'manageUsersFilterTeam',
  default: 0,
});

export const manageUsersFilterPermissionState = atom<number>({
  key: 'manageUsersFilterPermission',
  default: 0,
});

export const manageUsersOrganisationFilterState = atom<number>({
  key: 'manageUsersFilterOrganisation',
  default: 0,
});

export const manageUsersIsRegisteredFilterState = atom<number>({
  key: 'manageUsersIsRegisteredFilterOrganisation',
  default: 0,
});

export const inviteEmailState = atom<string>({
  key: 'inviteEmailField',
  default: '',
});

export const inviteNameState = atom<string>({
  key: 'inviteNameField',
  default: '',
});

export const inviteTeamsState = atom<ValueLabelResponse[]>({
  key: 'inviteTeams',
  default: [],
});

export const invitePermissionState = atom<number>({
  key: 'invitePermissionField',
  default: 0,
});

export const inviteRequestState = selector<InviteConsulteeRequest>({
  key: 'inviteFields',
  get: ({ get }) => ({
    name: get(inviteNameState),
    email: get(inviteEmailState),
    teamIds: get(inviteTeamsState).map((team) => team.value),
    permissionId: get(invitePermissionState),
  }),
});

export const useResetInviteUserState = (): (() => void) =>
  useRecoilTransaction_UNSTABLE(({ reset }) => () => {
    reset(inviteNameState);
    reset(inviteEmailState);
    reset(inviteTeamsState);
    reset(invitePermissionState);
  });
